import { isBrowser as xe, isDev as He, isSSR as Je, isBeta as Ue, isCanary as Be, isInternal as Le } from "@fond-of/env";
import { getLocalizedBaseUrl as Fe, getCurrentLocale as $e } from "@fond-of/locale";
import { getToken as Ke, isTokenExpired as Ge, logout as Ve } from "@fond-of/token-manager";
import { Storage as Xe } from "@fond-of/storage";
class K extends Error {
  constructor(t, n, r) {
    const o = t.status || t.status === 0 ? t.status : "", i = t.statusText || "", s = `${o} ${i}`.trim(), a = s ? `status code ${s}` : "an unknown error";
    super(`Request failed with ${a}`), Object.defineProperty(this, "response", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "request", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "options", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), this.name = "HTTPError", this.response = t, this.request = n, this.options = r;
  }
}
class ue extends Error {
  constructor(t) {
    super("Request timed out"), Object.defineProperty(this, "request", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), this.name = "TimeoutError", this.request = t;
  }
}
const T = (e) => e !== null && typeof e == "object", P = (...e) => {
  for (const t of e)
    if ((!T(t) || Array.isArray(t)) && t !== void 0)
      throw new TypeError("The `options` argument must be an object");
  return H({}, ...e);
}, ce = (e = {}, t = {}) => {
  const n = new globalThis.Headers(e), r = t instanceof globalThis.Headers, o = new globalThis.Headers(t);
  for (const [i, s] of o.entries())
    r && s === "undefined" || s === void 0 ? n.delete(i) : n.set(i, s);
  return n;
}, H = (...e) => {
  let t = {}, n = {};
  for (const r of e)
    if (Array.isArray(r))
      Array.isArray(t) || (t = []), t = [...t, ...r];
    else if (T(r)) {
      for (let [o, i] of Object.entries(r))
        T(i) && o in t && (i = H(t[o], i)), t = { ...t, [o]: i };
      T(r.headers) && (n = ce(n, r.headers), t.headers = n);
    }
  return t;
}, Ye = (() => {
  let e = !1, t = !1;
  const n = typeof globalThis.ReadableStream == "function", r = typeof globalThis.Request == "function";
  return n && r && (t = new globalThis.Request("https://empty.invalid", {
    body: new globalThis.ReadableStream(),
    method: "POST",
    // @ts-expect-error - Types are outdated.
    get duplex() {
      return e = !0, "half";
    }
  }).headers.has("Content-Type")), e && !t;
})(), We = typeof globalThis.AbortController == "function", Qe = typeof globalThis.ReadableStream == "function", Ze = typeof globalThis.FormData == "function", le = ["get", "post", "put", "patch", "head", "delete"], et = {
  json: "application/json",
  text: "text/*",
  formData: "multipart/form-data",
  arrayBuffer: "*/*",
  blob: "*/*"
}, z = 2147483647, fe = Symbol("stop"), tt = {
  json: !0,
  parseJson: !0,
  stringifyJson: !0,
  searchParams: !0,
  prefixUrl: !0,
  retry: !0,
  timeout: !0,
  hooks: !0,
  throwHttpErrors: !0,
  onDownloadProgress: !0,
  fetch: !0
}, rt = {
  method: !0,
  headers: !0,
  body: !0,
  mode: !0,
  credentials: !0,
  cache: !0,
  redirect: !0,
  referrer: !0,
  referrerPolicy: !0,
  integrity: !0,
  keepalive: !0,
  signal: !0,
  window: !0,
  dispatcher: !0,
  duplex: !0,
  priority: !0
}, nt = (e) => le.includes(e) ? e.toUpperCase() : e, it = ["get", "put", "head", "delete", "options", "trace"], ot = [408, 413, 429, 500, 502, 503, 504], pe = [413, 429, 503], G = {
  limit: 2,
  methods: it,
  statusCodes: ot,
  afterStatusCodes: pe,
  maxRetryAfter: Number.POSITIVE_INFINITY,
  backoffLimit: Number.POSITIVE_INFINITY,
  delay: (e) => 0.3 * 2 ** (e - 1) * 1e3
}, st = (e = {}) => {
  if (typeof e == "number")
    return {
      ...G,
      limit: e
    };
  if (e.methods && !Array.isArray(e.methods))
    throw new Error("retry.methods must be an array");
  if (e.statusCodes && !Array.isArray(e.statusCodes))
    throw new Error("retry.statusCodes must be an array");
  return {
    ...G,
    ...e,
    afterStatusCodes: pe
  };
};
async function at(e, t, n, r) {
  return new Promise((o, i) => {
    const s = setTimeout(() => {
      n && n.abort(), i(new ue(e));
    }, r.timeout);
    r.fetch(e, t).then(o).catch(i).then(() => {
      clearTimeout(s);
    });
  });
}
async function ut(e, { signal: t }) {
  return new Promise((n, r) => {
    t && (t.throwIfAborted(), t.addEventListener("abort", o, { once: !0 }));
    function o() {
      clearTimeout(i), r(t.reason);
    }
    const i = setTimeout(() => {
      t == null || t.removeEventListener("abort", o), n();
    }, e);
  });
}
const ct = (e, t) => {
  const n = {};
  for (const r in t)
    !(r in rt) && !(r in tt) && !(r in e) && (n[r] = t[r]);
  return n;
};
class A {
  static create(t, n) {
    const r = new A(t, n), o = async () => {
      if (typeof r._options.timeout == "number" && r._options.timeout > z)
        throw new RangeError(`The \`timeout\` option cannot be greater than ${z}`);
      await Promise.resolve();
      let a = await r._fetch();
      for (const u of r._options.hooks.afterResponse) {
        const c = await u(r.request, r._options, r._decorateResponse(a.clone()));
        c instanceof globalThis.Response && (a = c);
      }
      if (r._decorateResponse(a), !a.ok && r._options.throwHttpErrors) {
        let u = new K(a, r.request, r._options);
        for (const c of r._options.hooks.beforeError)
          u = await c(u);
        throw u;
      }
      if (r._options.onDownloadProgress) {
        if (typeof r._options.onDownloadProgress != "function")
          throw new TypeError("The `onDownloadProgress` option must be a function");
        if (!Qe)
          throw new Error("Streams are not supported in your environment. `ReadableStream` is missing.");
        return r._stream(a.clone(), r._options.onDownloadProgress);
      }
      return a;
    }, s = r._options.retry.methods.includes(r.request.method.toLowerCase()) ? r._retry(o) : o();
    for (const [a, u] of Object.entries(et))
      s[a] = async () => {
        r.request.headers.set("accept", r.request.headers.get("accept") || u);
        const l = (await s).clone();
        if (a === "json") {
          if (l.status === 204 || (await l.clone().arrayBuffer()).byteLength === 0)
            return "";
          if (n.parseJson)
            return n.parseJson(await l.text());
        }
        return l[a]();
      };
    return s;
  }
  // eslint-disable-next-line complexity
  constructor(t, n = {}) {
    var o, i;
    Object.defineProperty(this, "request", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "abortController", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "_retryCount", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: 0
    }), Object.defineProperty(this, "_input", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "_options", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), this._input = t;
    const r = this._input instanceof Request && "credentials" in Request.prototype ? this._input.credentials : void 0;
    if (this._options = {
      ...r && { credentials: r },
      // For exactOptionalPropertyTypes
      ...n,
      headers: ce(this._input.headers, n.headers),
      hooks: H({
        beforeRequest: [],
        beforeRetry: [],
        beforeError: [],
        afterResponse: []
      }, n.hooks),
      method: nt(n.method ?? this._input.method),
      // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
      prefixUrl: String(n.prefixUrl || ""),
      retry: st(n.retry),
      throwHttpErrors: n.throwHttpErrors !== !1,
      timeout: n.timeout ?? 1e4,
      fetch: n.fetch ?? globalThis.fetch.bind(globalThis)
    }, typeof this._input != "string" && !(this._input instanceof URL || this._input instanceof globalThis.Request))
      throw new TypeError("`input` must be a string, URL, or Request");
    if (this._options.prefixUrl && typeof this._input == "string") {
      if (this._input.startsWith("/"))
        throw new Error("`input` must not begin with a slash when using `prefixUrl`");
      this._options.prefixUrl.endsWith("/") || (this._options.prefixUrl += "/"), this._input = this._options.prefixUrl + this._input;
    }
    if (We) {
      if (this.abortController = new globalThis.AbortController(), this._options.signal) {
        const s = this._options.signal;
        this._options.signal.addEventListener("abort", () => {
          this.abortController.abort(s.reason);
        });
      }
      this._options.signal = this.abortController.signal;
    }
    if (Ye && (this._options.duplex = "half"), this.request = new globalThis.Request(this._input, this._options), this._options.searchParams) {
      const a = "?" + (typeof this._options.searchParams == "string" ? this._options.searchParams.replace(/^\?/, "") : new URLSearchParams(this._options.searchParams).toString()), u = this.request.url.replace(/(?:\?.*?)?(?=#|$)/, a);
      (Ze && this._options.body instanceof globalThis.FormData || this._options.body instanceof URLSearchParams) && !(this._options.headers && this._options.headers["content-type"]) && this.request.headers.delete("content-type"), this.request = new globalThis.Request(new globalThis.Request(u, { ...this.request }), this._options);
    }
    this._options.json !== void 0 && (this._options.body = ((i = (o = this._options).stringifyJson) == null ? void 0 : i.call(o, this._options.json)) ?? JSON.stringify(this._options.json), this.request.headers.set("content-type", this._options.headers.get("content-type") ?? "application/json"), this.request = new globalThis.Request(this.request, { body: this._options.body }));
  }
  _calculateRetryDelay(t) {
    if (this._retryCount++, this._retryCount <= this._options.retry.limit && !(t instanceof ue)) {
      if (t instanceof K) {
        if (!this._options.retry.statusCodes.includes(t.response.status))
          return 0;
        const r = t.response.headers.get("Retry-After");
        if (r && this._options.retry.afterStatusCodes.includes(t.response.status)) {
          let o = Number(r);
          return Number.isNaN(o) ? o = Date.parse(r) - Date.now() : o *= 1e3, this._options.retry.maxRetryAfter !== void 0 && o > this._options.retry.maxRetryAfter ? 0 : o;
        }
        if (t.response.status === 413)
          return 0;
      }
      const n = this._options.retry.delay(this._retryCount);
      return Math.min(this._options.retry.backoffLimit, n);
    }
    return 0;
  }
  _decorateResponse(t) {
    return this._options.parseJson && (t.json = async () => this._options.parseJson(await t.text())), t;
  }
  async _retry(t) {
    try {
      return await t();
    } catch (n) {
      const r = Math.min(this._calculateRetryDelay(n), z);
      if (r !== 0 && this._retryCount > 0) {
        await ut(r, { signal: this._options.signal });
        for (const o of this._options.hooks.beforeRetry)
          if (await o({
            request: this.request,
            options: this._options,
            error: n,
            retryCount: this._retryCount
          }) === fe)
            return;
        return this._retry(t);
      }
      throw n;
    }
  }
  async _fetch() {
    for (const n of this._options.hooks.beforeRequest) {
      const r = await n(this.request, this._options);
      if (r instanceof Request) {
        this.request = r;
        break;
      }
      if (r instanceof Response)
        return r;
    }
    const t = ct(this.request, this._options);
    return this._options.timeout === !1 ? this._options.fetch(this.request.clone(), t) : at(this.request.clone(), t, this.abortController, this._options);
  }
  /* istanbul ignore next */
  _stream(t, n) {
    const r = Number(t.headers.get("content-length")) || 0;
    let o = 0;
    return t.status === 204 ? (n && n({ percent: 1, totalBytes: r, transferredBytes: o }, new Uint8Array()), new globalThis.Response(null, {
      status: t.status,
      statusText: t.statusText,
      headers: t.headers
    })) : new globalThis.Response(new globalThis.ReadableStream({
      async start(i) {
        const s = t.body.getReader();
        n && n({ percent: 0, transferredBytes: 0, totalBytes: r }, new Uint8Array());
        async function a() {
          const { done: u, value: c } = await s.read();
          if (u) {
            i.close();
            return;
          }
          if (n) {
            o += c.byteLength;
            const l = r === 0 ? 0 : o / r;
            n({ percent: l, transferredBytes: o, totalBytes: r }, c);
          }
          i.enqueue(c), await a();
        }
        await a();
      }
    }), {
      status: t.status,
      statusText: t.statusText,
      headers: t.headers
    });
  }
}
/*! MIT License © Sindre Sorhus */
const N = (e) => {
  const t = (n, r) => A.create(n, P(e, r));
  for (const n of le)
    t[n] = (r, o) => A.create(r, P(e, o, { method: n }));
  return t.create = (n) => N(P(n)), t.extend = (n) => N(P(e, n)), t.stop = fe, t;
}, lt = N();
function ft(e) {
  if (Object.prototype.hasOwnProperty.call(e, "__esModule")) return e;
  var t = e.default;
  if (typeof t == "function") {
    var n = function r() {
      return this instanceof r ? Reflect.construct(t, arguments, this.constructor) : t.apply(this, arguments);
    };
    n.prototype = t.prototype;
  } else n = {};
  return Object.defineProperty(n, "__esModule", { value: !0 }), Object.keys(e).forEach(function(r) {
    var o = Object.getOwnPropertyDescriptor(e, r);
    Object.defineProperty(n, r, o.get ? o : {
      enumerable: !0,
      get: function() {
        return e[r];
      }
    });
  }), n;
}
var q = {}, S = {}, m = {}, V;
function J() {
  if (V) return m;
  V = 1, Object.defineProperty(m, "__esModule", { value: !0 }), m.isPlainObject = m.jsonParse = m.createIncludeNamesTree = void 0;
  function e(r, o) {
    var i = r.split("."), s = i.shift(), a = i.length, u = null;
    a && (u = o[s] || {}, e(i.join("."), u)), o[s] = u;
  }
  m.createIncludeNamesTree = e;
  function t(r) {
    var o;
    try {
      o = JSON.parse(r);
    } catch (i) {
      o = {}, console.warn(i);
    }
    return o;
  }
  m.jsonParse = t;
  var n = function(r) {
    return !!r && typeof r == "object" && r.constructor === Object;
  };
  return m.isPlainObject = n, m;
}
var M = {}, x = function(e, t) {
  return x = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, r) {
    n.__proto__ = r;
  } || function(n, r) {
    for (var o in r) Object.prototype.hasOwnProperty.call(r, o) && (n[o] = r[o]);
  }, x(e, t);
};
function he(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
  x(e, t);
  function n() {
    this.constructor = e;
  }
  e.prototype = t === null ? Object.create(t) : (n.prototype = t.prototype, new n());
}
var C = function() {
  return C = Object.assign || function(t) {
    for (var n, r = 1, o = arguments.length; r < o; r++) {
      n = arguments[r];
      for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (t[i] = n[i]);
    }
    return t;
  }, C.apply(this, arguments);
};
function de(e, t) {
  var n = {};
  for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, r = Object.getOwnPropertySymbols(e); o < r.length; o++)
      t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
  return n;
}
function ye(e, t, n, r) {
  var o = arguments.length, i = o < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, n) : r, s;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") i = Reflect.decorate(e, t, n, r);
  else for (var a = e.length - 1; a >= 0; a--) (s = e[a]) && (i = (o < 3 ? s(i) : o > 3 ? s(t, n, i) : s(t, n)) || i);
  return o > 3 && i && Object.defineProperty(t, n, i), i;
}
function be(e, t) {
  return function(n, r) {
    t(n, r, e);
  };
}
function pt(e, t, n, r, o, i) {
  function s(_) {
    if (_ !== void 0 && typeof _ != "function") throw new TypeError("Function expected");
    return _;
  }
  for (var a = r.kind, u = a === "getter" ? "get" : a === "setter" ? "set" : "value", c = !t && e ? r.static ? e : e.prototype : null, l = t || (c ? Object.getOwnPropertyDescriptor(c, r.name) : {}), f, h = !1, p = n.length - 1; p >= 0; p--) {
    var d = {};
    for (var y in r) d[y] = y === "access" ? {} : r[y];
    for (var y in r.access) d.access[y] = r.access[y];
    d.addInitializer = function(_) {
      if (h) throw new TypeError("Cannot add initializers after decoration has completed");
      i.push(s(_ || null));
    };
    var v = (0, n[p])(a === "accessor" ? { get: l.get, set: l.set } : l[u], d);
    if (a === "accessor") {
      if (v === void 0) continue;
      if (v === null || typeof v != "object") throw new TypeError("Object expected");
      (f = s(v.get)) && (l.get = f), (f = s(v.set)) && (l.set = f), (f = s(v.init)) && o.unshift(f);
    } else (f = s(v)) && (a === "field" ? o.unshift(f) : l[u] = f);
  }
  c && Object.defineProperty(c, r.name, l), h = !0;
}
function ht(e, t, n) {
  for (var r = arguments.length > 2, o = 0; o < t.length; o++)
    n = r ? t[o].call(e, n) : t[o].call(e);
  return r ? n : void 0;
}
function dt(e) {
  return typeof e == "symbol" ? e : "".concat(e);
}
function yt(e, t, n) {
  return typeof t == "symbol" && (t = t.description ? "[".concat(t.description, "]") : ""), Object.defineProperty(e, "name", { configurable: !0, value: n ? "".concat(n, " ", t) : t });
}
function ve(e, t) {
  if (typeof Reflect == "object" && typeof Reflect.metadata == "function") return Reflect.metadata(e, t);
}
function _e(e, t, n, r) {
  function o(i) {
    return i instanceof n ? i : new n(function(s) {
      s(i);
    });
  }
  return new (n || (n = Promise))(function(i, s) {
    function a(l) {
      try {
        c(r.next(l));
      } catch (f) {
        s(f);
      }
    }
    function u(l) {
      try {
        c(r.throw(l));
      } catch (f) {
        s(f);
      }
    }
    function c(l) {
      l.done ? i(l.value) : o(l.value).then(a, u);
    }
    c((r = r.apply(e, t || [])).next());
  });
}
function me(e, t) {
  var n = { label: 0, sent: function() {
    if (i[0] & 1) throw i[1];
    return i[1];
  }, trys: [], ops: [] }, r, o, i, s;
  return s = { next: a(0), throw: a(1), return: a(2) }, typeof Symbol == "function" && (s[Symbol.iterator] = function() {
    return this;
  }), s;
  function a(c) {
    return function(l) {
      return u([c, l]);
    };
  }
  function u(c) {
    if (r) throw new TypeError("Generator is already executing.");
    for (; s && (s = 0, c[0] && (n = 0)), n; ) try {
      if (r = 1, o && (i = c[0] & 2 ? o.return : c[0] ? o.throw || ((i = o.return) && i.call(o), 0) : o.next) && !(i = i.call(o, c[1])).done) return i;
      switch (o = 0, i && (c = [c[0] & 2, i.value]), c[0]) {
        case 0:
        case 1:
          i = c;
          break;
        case 4:
          return n.label++, { value: c[1], done: !1 };
        case 5:
          n.label++, o = c[1], c = [0];
          continue;
        case 7:
          c = n.ops.pop(), n.trys.pop();
          continue;
        default:
          if (i = n.trys, !(i = i.length > 0 && i[i.length - 1]) && (c[0] === 6 || c[0] === 2)) {
            n = 0;
            continue;
          }
          if (c[0] === 3 && (!i || c[1] > i[0] && c[1] < i[3])) {
            n.label = c[1];
            break;
          }
          if (c[0] === 6 && n.label < i[1]) {
            n.label = i[1], i = c;
            break;
          }
          if (i && n.label < i[2]) {
            n.label = i[2], n.ops.push(c);
            break;
          }
          i[2] && n.ops.pop(), n.trys.pop();
          continue;
      }
      c = t.call(e, n);
    } catch (l) {
      c = [6, l], o = 0;
    } finally {
      r = i = 0;
    }
    if (c[0] & 5) throw c[1];
    return { value: c[0] ? c[1] : void 0, done: !0 };
  }
}
var D = Object.create ? function(e, t, n, r) {
  r === void 0 && (r = n);
  var o = Object.getOwnPropertyDescriptor(t, n);
  (!o || ("get" in o ? !t.__esModule : o.writable || o.configurable)) && (o = { enumerable: !0, get: function() {
    return t[n];
  } }), Object.defineProperty(e, r, o);
} : function(e, t, n, r) {
  r === void 0 && (r = n), e[r] = t[n];
};
function we(e, t) {
  for (var n in e) n !== "default" && !Object.prototype.hasOwnProperty.call(t, n) && D(t, e, n);
}
function I(e) {
  var t = typeof Symbol == "function" && Symbol.iterator, n = t && e[t], r = 0;
  if (n) return n.call(e);
  if (e && typeof e.length == "number") return {
    next: function() {
      return e && r >= e.length && (e = void 0), { value: e && e[r++], done: !e };
    }
  };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function U(e, t) {
  var n = typeof Symbol == "function" && e[Symbol.iterator];
  if (!n) return e;
  var r = n.call(e), o, i = [], s;
  try {
    for (; (t === void 0 || t-- > 0) && !(o = r.next()).done; ) i.push(o.value);
  } catch (a) {
    s = { error: a };
  } finally {
    try {
      o && !o.done && (n = r.return) && n.call(r);
    } finally {
      if (s) throw s.error;
    }
  }
  return i;
}
function ge() {
  for (var e = [], t = 0; t < arguments.length; t++)
    e = e.concat(U(arguments[t]));
  return e;
}
function Me() {
  for (var e = 0, t = 0, n = arguments.length; t < n; t++) e += arguments[t].length;
  for (var r = Array(e), o = 0, t = 0; t < n; t++)
    for (var i = arguments[t], s = 0, a = i.length; s < a; s++, o++)
      r[o] = i[s];
  return r;
}
function Re(e, t, n) {
  if (n || arguments.length === 2) for (var r = 0, o = t.length, i; r < o; r++)
    (i || !(r in t)) && (i || (i = Array.prototype.slice.call(t, 0, r)), i[r] = t[r]);
  return e.concat(i || Array.prototype.slice.call(t));
}
function O(e) {
  return this instanceof O ? (this.v = e, this) : new O(e);
}
function Oe(e, t, n) {
  if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
  var r = n.apply(e, t || []), o, i = [];
  return o = {}, a("next"), a("throw"), a("return", s), o[Symbol.asyncIterator] = function() {
    return this;
  }, o;
  function s(p) {
    return function(d) {
      return Promise.resolve(d).then(p, f);
    };
  }
  function a(p, d) {
    r[p] && (o[p] = function(y) {
      return new Promise(function(v, _) {
        i.push([p, y, v, _]) > 1 || u(p, y);
      });
    }, d && (o[p] = d(o[p])));
  }
  function u(p, d) {
    try {
      c(r[p](d));
    } catch (y) {
      h(i[0][3], y);
    }
  }
  function c(p) {
    p.value instanceof O ? Promise.resolve(p.value.v).then(l, f) : h(i[0][2], p);
  }
  function l(p) {
    u("next", p);
  }
  function f(p) {
    u("throw", p);
  }
  function h(p, d) {
    p(d), i.shift(), i.length && u(i[0][0], i[0][1]);
  }
}
function Pe(e) {
  var t, n;
  return t = {}, r("next"), r("throw", function(o) {
    throw o;
  }), r("return"), t[Symbol.iterator] = function() {
    return this;
  }, t;
  function r(o, i) {
    t[o] = e[o] ? function(s) {
      return (n = !n) ? { value: O(e[o](s)), done: !1 } : i ? i(s) : s;
    } : i;
  }
}
function Se(e) {
  if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
  var t = e[Symbol.asyncIterator], n;
  return t ? t.call(e) : (e = typeof I == "function" ? I(e) : e[Symbol.iterator](), n = {}, r("next"), r("throw"), r("return"), n[Symbol.asyncIterator] = function() {
    return this;
  }, n);
  function r(i) {
    n[i] = e[i] && function(s) {
      return new Promise(function(a, u) {
        s = e[i](s), o(a, u, s.done, s.value);
      });
    };
  }
  function o(i, s, a, u) {
    Promise.resolve(u).then(function(c) {
      i({ value: c, done: a });
    }, s);
  }
}
function je(e, t) {
  return Object.defineProperty ? Object.defineProperty(e, "raw", { value: t }) : e.raw = t, e;
}
var bt = Object.create ? function(e, t) {
  Object.defineProperty(e, "default", { enumerable: !0, value: t });
} : function(e, t) {
  e.default = t;
};
function Ee(e) {
  if (e && e.__esModule) return e;
  var t = {};
  if (e != null) for (var n in e) n !== "default" && Object.prototype.hasOwnProperty.call(e, n) && D(t, e, n);
  return bt(t, e), t;
}
function Te(e) {
  return e && e.__esModule ? e : { default: e };
}
function Ae(e, t, n, r) {
  if (n === "a" && !r) throw new TypeError("Private accessor was defined without a getter");
  if (typeof t == "function" ? e !== t || !r : !t.has(e)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
  return n === "m" ? r : n === "a" ? r.call(e) : r ? r.value : t.get(e);
}
function Ce(e, t, n, r, o) {
  if (r === "m") throw new TypeError("Private method is not writable");
  if (r === "a" && !o) throw new TypeError("Private accessor was defined without a setter");
  if (typeof t == "function" ? e !== t || !o : !t.has(e)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
  return r === "a" ? o.call(e, n) : o ? o.value = n : t.set(e, n), n;
}
function Ie(e, t) {
  if (t === null || typeof t != "object" && typeof t != "function") throw new TypeError("Cannot use 'in' operator on non-object");
  return typeof e == "function" ? t === e : e.has(t);
}
function De(e, t, n) {
  if (t != null) {
    if (typeof t != "object" && typeof t != "function") throw new TypeError("Object expected.");
    var r, o;
    if (n) {
      if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
      r = t[Symbol.asyncDispose];
    }
    if (r === void 0) {
      if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
      r = t[Symbol.dispose], n && (o = r);
    }
    if (typeof r != "function") throw new TypeError("Object not disposable.");
    o && (r = function() {
      try {
        o.call(this);
      } catch (i) {
        return Promise.reject(i);
      }
    }), e.stack.push({ value: t, dispose: r, async: n });
  } else n && e.stack.push({ async: !0 });
  return t;
}
var vt = typeof SuppressedError == "function" ? SuppressedError : function(e, t, n) {
  var r = new Error(n);
  return r.name = "SuppressedError", r.error = e, r.suppressed = t, r;
};
function ze(e) {
  function t(r) {
    e.error = e.hasError ? new vt(r, e.error, "An error was suppressed during disposal.") : r, e.hasError = !0;
  }
  function n() {
    for (; e.stack.length; ) {
      var r = e.stack.pop();
      try {
        var o = r.dispose && r.dispose.call(r.value);
        if (r.async) return Promise.resolve(o).then(n, function(i) {
          return t(i), n();
        });
      } catch (i) {
        t(i);
      }
    }
    if (e.hasError) throw e.error;
  }
  return n();
}
const _t = {
  __extends: he,
  __assign: C,
  __rest: de,
  __decorate: ye,
  __param: be,
  __metadata: ve,
  __awaiter: _e,
  __generator: me,
  __createBinding: D,
  __exportStar: we,
  __values: I,
  __read: U,
  __spread: ge,
  __spreadArrays: Me,
  __spreadArray: Re,
  __await: O,
  __asyncGenerator: Oe,
  __asyncDelegator: Pe,
  __asyncValues: Se,
  __makeTemplateObject: je,
  __importStar: Ee,
  __importDefault: Te,
  __classPrivateFieldGet: Ae,
  __classPrivateFieldSet: Ce,
  __classPrivateFieldIn: Ie,
  __addDisposableResource: De,
  __disposeResources: ze
}, mt = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  __addDisposableResource: De,
  get __assign() {
    return C;
  },
  __asyncDelegator: Pe,
  __asyncGenerator: Oe,
  __asyncValues: Se,
  __await: O,
  __awaiter: _e,
  __classPrivateFieldGet: Ae,
  __classPrivateFieldIn: Ie,
  __classPrivateFieldSet: Ce,
  __createBinding: D,
  __decorate: ye,
  __disposeResources: ze,
  __esDecorate: pt,
  __exportStar: we,
  __extends: he,
  __generator: me,
  __importDefault: Te,
  __importStar: Ee,
  __makeTemplateObject: je,
  __metadata: ve,
  __param: be,
  __propKey: dt,
  __read: U,
  __rest: de,
  __runInitializers: ht,
  __setFunctionName: yt,
  __spread: ge,
  __spreadArray: Re,
  __spreadArrays: Me,
  __values: I,
  default: _t
}, Symbol.toStringTag, { value: "Module" })), B = /* @__PURE__ */ ft(mt);
var X;
function qe() {
  if (X) return M;
  X = 1, Object.defineProperty(M, "__esModule", { value: !0 }), M.ModelsSerializer = void 0;
  var e = B, t = J(), n = function() {
    function r(o) {
      o && this.setPropertiesMapper(o), this.buildIncludedIndex = 0;
    }
    return r.prototype.setPropertiesMapper = function(o) {
      this.propertiesMapper = o;
    }, r.prototype.setStuff = function(o) {
      this.stuff = o;
    }, r.prototype.setIncludeNames = function(o) {
      if (Array.isArray(o)) {
        var i = {};
        o.forEach(function(s) {
          (0, t.createIncludeNamesTree)(s, i);
        }), this.includeNamesTree = i;
      } else
        this.includeNamesTree = o;
    }, r.prototype.build = function() {
      var o = this, i = o.stuff, s = o.propertiesMapper;
      if (!s || typeof s != "object")
        throw new Error("ModelsSerializer cannot build, propertiesMapper is not set");
      if (!i || typeof i != "object")
        throw new Error("ModelsSerializer cannot build, stuff is not set");
      var a = {}, u = {};
      if (i && Array.isArray(i)) {
        for (var c = i.length, l = [], f = 0; f < c; f++)
          l.push(this.buildDataByModel(i[f])), this.buildIncludedByModel(i[f], this.includeNamesTree, u);
        a.data = l;
      } else i ? (a.data = this.buildDataByModel(i), this.buildIncludedByModel(i, this.includeNamesTree, u)) : i === null && (a.data = null);
      return Object.keys(u).length && (a.included = Object.values(u)), a;
    }, r.prototype.buildDataByModel = function(o) {
      var i = this.propertiesMapper.getId(o), s = this.propertiesMapper.getType(o), a = this.propertiesMapper.getAttributes(o), u = e.__assign(e.__assign({ type: s }, typeof i < "u" ? { id: i } : {}), typeof a < "u" ? { attributes: a } : {});
      if (typeof u.type != "string" || !u.type)
        throw console.warn("ModelsSerializer cannot buildDataByModel, type is not set or incorrect", o), new Error("ModelsSerializer cannot buildDataByModel, type is not set or incorrect");
      var c = this.buildRelationshipsByModel(o);
      return c && Object.keys(c).length && (u.relationships = c), u;
    }, r.prototype.buildResourceObjectPart = function(o) {
      var i = this.propertiesMapper.getId(o), s = this.propertiesMapper.getType(o);
      return e.__assign({ type: s }, typeof i > "u" ? {} : { id: i });
    }, r.prototype.buildRelationshipsByModel = function(o) {
      var i = this, s = this.propertiesMapper.getRelationships(o);
      if (!(!s || !Object.keys(s).length)) {
        var a = {};
        return Object.keys(s).forEach(function(u) {
          var c = s[u];
          if (Array.isArray(c)) {
            for (var l = [], f = 0, h = c; f < h.length; f++) {
              var p = h[f], d = i.buildResourceObjectPart(p);
              "type" in d ? l.push(d) : console.error("Can't create data item for relationship ".concat(u, `,
                            it doesn't have 'id' or 'type', it was skipped`), p);
            }
            a[u] = {
              data: l
            };
          } else if (c) {
            var y = i.buildResourceObjectPart(c);
            "type" in y ? a[u] = {
              data: y
            } : console.error("Can't create data for relationship ".concat(u, ", it doesn't have 'type', it was skipped"), c);
          } else
            a[u] = {
              data: c
            };
        }), a;
      }
    }, r.prototype.buildIncludedByModel = function(o, i, s) {
      if (s === void 0 && (s = {}), !(!i || !Object.keys(i).length)) {
        var a = this.propertiesMapper.getRelationships(o);
        if (!(!a || !Object.keys(a).length))
          for (var u = Object.keys(i), c = u.length, l = 0; l < c; l++) {
            var f = u[l], h = a[f];
            if (h)
              if (Array.isArray(h))
                for (var p = h.length, d = 0; d < p; d++) {
                  var y = h[d];
                  this.buildIncludedItem(y, i[f], s);
                }
              else
                this.buildIncludedItem(h, i[f], s);
          }
      }
    }, r.prototype.buildIncludedItem = function(o, i, s) {
      var a = this.propertiesMapper.getId(o), u = this.propertiesMapper.getType(o), c = u + a;
      (!a || !s[c]) && (c in s && (c += this.buildIncludedIndex, this.buildIncludedIndex += 1), s[c] = this.buildDataByModel(o), i && this.buildIncludedByModel(o, i, s));
    }, r;
  }();
  return M.ModelsSerializer = n, M.default = n, M;
}
var R = {}, Y;
function ke() {
  if (Y) return R;
  Y = 1, Object.defineProperty(R, "__esModule", { value: !0 }), R.JsonDeserializer = void 0;
  var e = function() {
    function t(n, r, o) {
      this.preferNestedDataFromData = !1, this.setPropertiesMapper(n), this.setDeserializeCache(r), o && o.preferNestedDataFromData && (this.preferNestedDataFromData = !0);
    }
    return t.prototype.setDeserializeCache = function(n) {
      this.dc = n;
    }, t.prototype.setPropertiesMapper = function(n) {
      this.pm = n;
    }, t.prototype.setJsonParsedObject = function(n) {
      this.body = n;
    }, t.prototype.build = function() {
      var n = this.body.data, r;
      if (Array.isArray(n)) {
        r = [];
        for (var o = n.length, i = 0; i < o; i++)
          if (n[i]) {
            var s = this.buildModelByData(n[i]);
            s && r.push(s);
          }
      } else n && (r = this.buildModelByData(n));
      return r;
    }, t.prototype.buildModelByData = function(n, r) {
      var o = this.dc.getCachedModel(n, r);
      if (o)
        return o;
      var i = this.pm.createModel(n.type);
      if (this.dc.handleModel(i, n, r), i) {
        this.pm.setId(i, n.id), n.attributes && this.pm.setAttributes(i, n.attributes), n.meta && this.pm.setMeta && this.pm.setMeta(i, n.meta), n.links && this.pm.setLinks && this.pm.setLinks(i, n.links), r != null && r.meta && this.pm.setResourceIdObjMeta(i, r.meta);
        var s = this.buildRelationsByData(n, i);
        s && this.pm.setRelationships(i, s);
      }
      return i;
    }, t.prototype.buildRelationsByData = function(n, r) {
      var o = {};
      if (n.relationships)
        for (var i in n.relationships) {
          var s = n.relationships[i];
          if (Array.isArray(s.data)) {
            o[i] = [];
            for (var a = s.data.length, u = void 0, c = 0; c < a; c++)
              if (u = s.data[c], !!u) {
                var l = this.buildDataFromIncludedOrData(u.id, u.type);
                o[i].push(this.buildModelByData(l, u));
              }
          } else if (s.data) {
            var l = this.buildDataFromIncludedOrData(s.data.id, s.data.type);
            o[i] = this.buildModelByData(l, s.data);
          } else s.data === null && (o[i] = null);
          if (s.links) {
            var f = this.pm.setRelationshipLinks;
            f && f(r, i, s.links);
          }
          if (s.meta) {
            var h = this.pm.setRelationshipMeta;
            h && h(r, i, s.meta);
          }
        }
      return Object.keys(o).length ? o : null;
    }, t.prototype.buildDataFromIncludedOrData = function(n, r) {
      if (this.preferNestedDataFromData) {
        var o = this.buildDataInObject(), i = o[r + n];
        if (i)
          return i;
      }
      var s = this.buildIncludedInObject(), a = s[r + n];
      if (a)
        return a;
      if (!this.preferNestedDataFromData) {
        var o = this.buildDataInObject(), i = o[r + n];
        if (i)
          return i;
      }
      return { id: n, type: r };
    }, t.prototype.buildDataInObject = function() {
      if (!this.dataInObject) {
        this.dataInObject = {};
        var n = this.body.data, r = n.length;
        if (n && r)
          for (var o = 0; o < r; o++) {
            var i = n[o];
            this.dataInObject[i.type + i.id] = i;
          }
        else n && (this.dataInObject[n.type + n.id] = n);
      }
      return this.dataInObject;
    }, t.prototype.buildIncludedInObject = function() {
      if (!this.includedInObject && (this.includedInObject = {}, this.body.included))
        for (var n = this.body.included.length, r = 0; r < n; r++) {
          var o = this.body.included[r];
          this.includedInObject[o.type + o.id] = o;
        }
      return this.includedInObject;
    }, t;
  }();
  return R.JsonDeserializer = e, R.default = e, R;
}
var j = {}, W;
function wt() {
  if (W) return j;
  W = 1, Object.defineProperty(j, "__esModule", { value: !0 });
  var e = function() {
    function t(n) {
      this.cachedModels = {}, this.setPropertiesMapper(n);
    }
    return t.prototype.setPropertiesMapper = function(n) {
      this.propertiesMapper = n;
    }, t.prototype.setReduxObject = function(n) {
      this.reduxObject = n;
    }, t.prototype.setEntityType = function(n) {
      this.entityType = n;
    }, t.prototype.setEntityIds = function(n) {
      this.ids = n;
    }, t.prototype.setReturnBuilderInRelations = function(n) {
      this.returnBuilderInRelations = n;
    }, t.prototype.build = function() {
      var n = this, r = this, o = r.reduxObject, i = r.entityType, s = r.propertiesMapper;
      if (!s || typeof s != "object")
        throw new Error("ReduxObjectDenormalizer cannot build, propertiesMapper is not set");
      if (!o || typeof o != "object")
        throw new Error("ReduxObjectDenormalizer cannot build, reduxObject is not set");
      if (!i)
        throw new Error("ReduxObjectDenormalizer cannot build, entityType is not set");
      if (!o[i])
        return null;
      var a = this.ids;
      if (a || (a = Object.keys(o[i])), Array.isArray(a)) {
        if (!a.length)
          return null;
        var u = [];
        return a.forEach(function(c) {
          var l = n.buildModel(i, c);
          l && u.push(l);
        }), u;
      }
      return this.buildModel(i, a);
    }, t.prototype.buildModel = function(n, r) {
      var o = this.reduxObject;
      if (!o[n])
        return null;
      var i = o[n][r];
      if (!i)
        return null;
      var s = "".concat(n, "-").concat(r), a = this.cachedModels[s];
      if (!a && (a = this.propertiesMapper.createModel(n), a)) {
        this.cachedModels[s] = a, this.propertiesMapper.setId(a, i.id), i.attributes && this.propertiesMapper.setAttributes(a, i.attributes);
        var u = this.buildRelationships(a, i.relationships);
        u && this.propertiesMapper.setRelationships(a, u);
      }
      return a;
    }, t.prototype.buildRelationships = function(n, r) {
      var o = this;
      if (!r)
        return null;
      var i = Object.keys(r);
      if (!i.length)
        return null;
      var s = {};
      return i.forEach(function(a) {
        var u = r[a];
        if (u && u.data && (o.returnBuilderInRelations ? s[a] = o.buildRelationModels.bind(o, u.data) : s[a] = o.buildRelationModels(u.data)), u && u.links && o.propertiesMapper.setRelationshipLinks(n, a, u.links), u && u.meta) {
          var c = o.propertiesMapper.setRelationshipMeta;
          c && c(n, a, u.meta);
        }
      }), Object.keys(s).length ? s : null;
    }, t.prototype.buildRelationModels = function(n) {
      var r = this;
      if (Array.isArray(n)) {
        var o = [];
        return n.forEach(function(i) {
          var s = r.buildModel(i.type, i.id);
          o.push(s || i);
        }), o;
      } else if (n.id && n.type)
        return this.buildModel(n.type, n.id) || n;
      return null;
    }, t;
  }();
  return j.default = e, j;
}
var k = {}, Q;
function L() {
  return Q || (Q = 1, function(e) {
    Object.defineProperty(e, "__esModule", { value: !0 }), e.JsonPropertiesMapper = e.defineRelationGetter = e.ModelPropertiesMapper = e.RELATIONSHIP_NAMES_PROP = void 0;
    var t = B;
    e.RELATIONSHIP_NAMES_PROP = "relationshipNames";
    var n = function() {
      function i() {
      }
      return i.prototype.getId = function(s) {
        return s.id;
      }, i.prototype.getType = function(s) {
        return s.type;
      }, i.prototype.getAttributes = function(s) {
        var a = ["id", "type", e.RELATIONSHIP_NAMES_PROP];
        Array.isArray(s[e.RELATIONSHIP_NAMES_PROP]) ? a.push.apply(a, s[e.RELATIONSHIP_NAMES_PROP]) : s[e.RELATIONSHIP_NAMES_PROP] && console.warn("Can't getAttributes correctly, '".concat(e.RELATIONSHIP_NAMES_PROP, "' property of ").concat(s.type, "-").concat(s.id, ` model
                isn't array of relationship names`), s[e.RELATIONSHIP_NAMES_PROP]);
        var u = {};
        return Object.keys(s).forEach(function(c) {
          a.indexOf(c) === -1 && (u[c] = s[c]);
        }), u;
      }, i.prototype.getRelationships = function(s) {
        var a = s[e.RELATIONSHIP_NAMES_PROP];
        if (!(!a || Array.isArray(a) && !a.length)) {
          if (a && !Array.isArray(a)) {
            console.warn(`Can't getRelationships correctly,
                '`.concat(e.RELATIONSHIP_NAMES_PROP, "' property of ").concat(s.type, "-").concat(s.id, ` model
                isn't array of relationship names`), s[e.RELATIONSHIP_NAMES_PROP]);
            return;
          }
          var u = {};
          return a.forEach(function(c) {
            s[c] !== void 0 && (u[c] = s[c]);
          }), u;
        }
      }, i;
    }();
    e.ModelPropertiesMapper = n;
    function r(i, s, a) {
      Object.defineProperty(i, s, {
        enumerable: !0,
        configurable: !0,
        set: function(u) {
          delete i[s], i[s] = u;
        },
        get: function() {
          return delete i[s], i[s] = a();
        }
      });
    }
    e.defineRelationGetter = r;
    var o = function() {
      function i() {
      }
      return i.prototype.createModel = function(s) {
        return { type: s };
      }, i.prototype.setId = function(s, a) {
        s.id = a;
      }, i.prototype.setAttributes = function(s, a) {
        Object.keys(a).forEach(function(u) {
          s[u] = a[u];
        });
      }, i.prototype.setMeta = function(s, a) {
        s.meta = a;
      }, i.prototype.setLinks = function(s, a) {
        s.links = a;
      }, i.prototype.setResourceIdObjMeta = function(s, a) {
        s.resourceIdObjMeta = a;
      }, i.prototype.setRelationships = function(s, a) {
        Object.keys(a).forEach(function(l) {
          typeof a[l] == "function" ? r(s, l, a[l]) : s[l] = a[l];
        });
        var u = Object.keys(a), c = s[e.RELATIONSHIP_NAMES_PROP];
        c && c.length ? s[e.RELATIONSHIP_NAMES_PROP] = t.__spreadArray(t.__spreadArray([], c, !0), u, !0).filter(function(l, f, h) {
          return h.indexOf(l) === f;
        }) : s[e.RELATIONSHIP_NAMES_PROP] = u;
      }, i.prototype.setRelationshipLinks = function(s, a, u) {
      }, i.prototype.setRelationshipMeta = function(s, a, u) {
      }, i;
    }();
    e.JsonPropertiesMapper = o;
  }(k)), k;
}
var w = {}, Z;
function gt() {
  if (Z) return w;
  Z = 1, Object.defineProperty(w, "__esModule", { value: !0 }), w.DeserializeCache = w.jsonStringify = void 0;
  function e(n) {
    var r;
    try {
      r = JSON.stringify(n);
    } catch (o) {
      r = "", console.warn(o);
    }
    return r;
  }
  w.jsonStringify = e;
  var t = function() {
    function n() {
      this.cachedModels = {};
    }
    return n.prototype.getCachedModel = function(r, o) {
      var i = this.createCacheKey(r, o);
      return this.cachedModels[i] || null;
    }, n.prototype.handleModel = function(r, o, i) {
      var s = this.createCacheKey(o, i), a = o.attributes || o.relationships;
      s && a && (this.cachedModels[s] = r);
    }, n.prototype.createCacheKey = function(r, o) {
      if (!(!r.id || !r.type)) {
        var i = o ? "".concat(o.type, "-").concat(o.id) : "";
        return o != null && o.meta && (i += "-".concat(e(o.meta))), r.meta ? "".concat(r.type, "-").concat(r.id, "-").concat(e(r.meta), "-").concat(i) : "".concat(r.type, "-").concat(r.id, "-").concat(i);
      }
    }, n;
  }();
  return w.DeserializeCache = t, w;
}
var ee;
function Mt() {
  if (ee) return S;
  ee = 1, Object.defineProperty(S, "__esModule", { value: !0 });
  var e = J(), t = qe(), n = ke(), r = wt(), o = L(), i = gt(), s = function() {
    function a(u) {
      this.modelPropertiesMapper = new o.ModelPropertiesMapper(), this.jsonPropertiesMapper = new o.JsonPropertiesMapper(), this.DeserializeCache = i.DeserializeCache, this.ModelsSerializer = t.default, this.JsonDeserializer = n.default, u && u.modelPropertiesMapper && (this.modelPropertiesMapper = u.modelPropertiesMapper), u && u.jsonPropertiesMapper && (this.jsonPropertiesMapper = u.jsonPropertiesMapper), u && u.DeserializeCache && (this.DeserializeCache = u.DeserializeCache), u && u.ModelsSerializer && (this.ModelsSerializer = u.ModelsSerializer), u && u.JsonDeserializer && (this.JsonDeserializer = u.JsonDeserializer);
    }
    return a.prototype.serialize = function(u) {
      var c = u.stuff, l = u.includeNames;
      if (!c)
        throw new Error("Jsona can not serialize, stuff is not passed");
      var f = new this.ModelsSerializer(this.modelPropertiesMapper);
      return f.setStuff(c), l && f.setIncludeNames(l), f.build();
    }, a.prototype.deserialize = function(u, c) {
      if (!u)
        throw new Error("Jsona can not deserialize, body is not passed");
      var l = new this.DeserializeCache(), f = new this.JsonDeserializer(this.jsonPropertiesMapper, l, c);
      return typeof u == "string" ? f.setJsonParsedObject((0, e.jsonParse)(u)) : f.setJsonParsedObject(u), f.build();
    }, a.prototype.denormalizeReduxObject = function(u) {
      var c = u.reduxObject, l = u.entityType, f = u.entityIds, h = u.returnBuilderInRelations, p = h === void 0 ? !1 : h;
      if (!c)
        throw new Error("Jsona can not denormalize ReduxObject, incorrect reduxObject passed");
      if (!l)
        throw new Error("Jsona can not denormalize ReduxObject, entityType is not passed");
      if (!c[l])
        return null;
      var d = new r.default(this.jsonPropertiesMapper);
      return d.setReduxObject(c), d.setEntityType(l), d.setReturnBuilderInRelations(p), f && d.setEntityIds(Array.isArray(f) ? f : f.toString()), d.build();
    }, a;
  }();
  return S.default = s, S;
}
var g = {}, te;
function Rt() {
  if (te) return g;
  te = 1, Object.defineProperty(g, "__esModule", { value: !0 }), g.SwitchCaseJsonMapper = g.SwitchCaseModelMapper = void 0;
  var e = B, t = L(), n = J(), r = function(i) {
    e.__extends(s, i);
    function s(a) {
      var u = i.call(this) || this, c = a || {}, l = c.switchAttributes, f = l === void 0 ? !0 : l, h = c.switchRelationships, p = h === void 0 ? !0 : h, d = c.switchType, y = d === void 0 ? !0 : d, v = c.switchChar, _ = v === void 0 ? "-" : v;
      return u.switchAttributes = f, u.switchRelationships = p, u.switchType = y, u.switchChar = _, u.regex = new RegExp(/([a-z][A-Z0-9])/g), u;
    }
    return s.prototype.getType = function(a) {
      var u = i.prototype.getType.call(this, a);
      return !this.switchType || !u ? u : this.convertFromCamelCaseString(u);
    }, s.prototype.getAttributes = function(a) {
      var u = i.prototype.getAttributes.call(this, a);
      return !this.switchAttributes || !u ? u : this.convertFromCamelCase(u);
    }, s.prototype.getRelationships = function(a) {
      var u = i.prototype.getRelationships.call(this, a);
      return !this.switchRelationships || !u ? u : this.convertFromCamelCase(u);
    }, s.prototype.convertFromCamelCase = function(a) {
      var u = this;
      if (Array.isArray(a))
        return a.map(function(l) {
          return u.convertFromCamelCase(l);
        });
      if ((0, n.isPlainObject)(a)) {
        var c = {};
        return Object.entries(a).forEach(function(l) {
          var f = l[0], h = l[1], p = u.convertFromCamelCaseString(f);
          c[p] = u.convertFromCamelCase(h);
        }), c;
      }
      return a;
    }, s.prototype.convertFromCamelCaseString = function(a) {
      var u = this;
      return a.replace(this.regex, function(c) {
        return c[0] + u.switchChar + c[1].toLowerCase();
      });
    }, s;
  }(t.ModelPropertiesMapper);
  g.SwitchCaseModelMapper = r;
  var o = function(i) {
    e.__extends(s, i);
    function s(a) {
      var u = i.call(this) || this, c = a || {}, l = c.camelizeAttributes, f = l === void 0 ? !0 : l, h = c.camelizeRelationships, p = h === void 0 ? !0 : h, d = c.camelizeType, y = d === void 0 ? !0 : d, v = c.camelizeMeta, _ = v === void 0 ? !1 : v, $ = c.switchChar, Ne = $ === void 0 ? "-" : $;
      return u.camelizeAttributes = f, u.camelizeRelationships = p, u.camelizeType = y, u.camelizeMeta = _, u.switchChar = Ne, u.regex = new RegExp("".concat(u.switchChar, "([a-z0-9])"), "g"), u;
    }
    return s.prototype.createModel = function(a) {
      if (!this.camelizeType)
        return { type: a };
      var u = this.convertToCamelCaseString(a);
      return { type: u };
    }, s.prototype.setAttributes = function(a, u) {
      if (!this.camelizeAttributes)
        return i.prototype.setAttributes.call(this, a, u);
      Object.assign(a, this.convertToCamelCase(u));
    }, s.prototype.setMeta = function(a, u) {
      if (!this.camelizeMeta)
        return i.prototype.setMeta.call(this, a, u);
      a.meta = this.convertToCamelCase(u);
    }, s.prototype.setRelationships = function(a, u) {
      var c = this;
      i.prototype.setRelationships.call(this, a, u), this.camelizeRelationships && a[t.RELATIONSHIP_NAMES_PROP].forEach(function(l, f) {
        var h = c.convertToCamelCaseString(l);
        h !== l && (a[h] = a[l], delete a[l], a[t.RELATIONSHIP_NAMES_PROP][f] = h);
      });
    }, s.prototype.convertToCamelCase = function(a) {
      var u = this;
      if (Array.isArray(a))
        return a.map(function(l) {
          return u.convertToCamelCase(l);
        });
      if ((0, n.isPlainObject)(a)) {
        var c = {};
        return Object.entries(a).forEach(function(l) {
          var f = l[0], h = l[1], p = u.convertToCamelCaseString(f);
          c[p] = u.convertToCamelCase(h);
        }), c;
      }
      return a;
    }, s.prototype.convertToCamelCaseString = function(a) {
      return a.replace(this.regex, function(u) {
        return u[1].toUpperCase();
      });
    }, s;
  }(t.JsonPropertiesMapper);
  return g.SwitchCaseJsonMapper = o, g;
}
var re;
function Ot() {
  return re || (re = 1, function(e) {
    Object.defineProperty(e, "__esModule", { value: !0 }), e.SwitchCaseJsonMapper = e.SwitchCaseModelMapper = e.JsonPropertiesMapper = e.ModelPropertiesMapper = e.JsonDeserializer = e.ModelsSerializer = e.Jsona = void 0;
    var t = Mt();
    e.Jsona = t.default;
    var n = qe();
    e.ModelsSerializer = n.default;
    var r = ke();
    e.JsonDeserializer = r.default;
    var o = L();
    Object.defineProperty(e, "ModelPropertiesMapper", { enumerable: !0, get: function() {
      return o.ModelPropertiesMapper;
    } }), Object.defineProperty(e, "JsonPropertiesMapper", { enumerable: !0, get: function() {
      return o.JsonPropertiesMapper;
    } });
    var i = Rt();
    Object.defineProperty(e, "SwitchCaseModelMapper", { enumerable: !0, get: function() {
      return i.SwitchCaseModelMapper;
    } }), Object.defineProperty(e, "SwitchCaseJsonMapper", { enumerable: !0, get: function() {
      return i.SwitchCaseJsonMapper;
    } }), e.default = t.default;
  }(q)), q;
}
var ne = Ot();
const Pt = new ne.Jsona({
  jsonPropertiesMapper: new ne.SwitchCaseJsonMapper()
}), St = (...e) => Pt.deserialize(...e), jt = async (e, t, n) => {
  if (n.ok) {
    const r = await n.text();
    if (!r)
      return new Response(null, n);
    const o = St(r);
    return o ? new Response(JSON.stringify(o), n) : new Response(r, n);
  }
  return n;
}, Et = (e, t) => {
  var n, r;
  Je() || (r = (n = window.DD_RUM) == null ? void 0 : n.addError) == null || r.call(n, e, t);
}, Tt = (e, t) => {
  console.error(e, t);
}, At = (e, t) => {
  Et(e, t), xe() && He(window.location.host) && Tt(e, t);
}, Ct = async (e) => (At(e, {
  request: {
    url: e.request.url
  },
  response: {
    status: e.response.status,
    body: await It(e.response)
  }
}), e), It = async (e) => {
  try {
    return await e.clone().json();
  } catch {
    return await e.clone().text();
  }
}, Dt = (e) => {
  const { origin: t } = globalThis.location;
  return {
    ...e,
    prefixUrl: `${t}${Fe()}`
  };
}, zt = "Authorization", qt = "Bearer", kt = (e) => {
  const t = Ke();
  if (t && Ge(t)) {
    Ve();
    return;
  }
  t && e.headers.set(zt, `${qt} ${t}`);
}, Nt = "X-Fondof-Beta", xt = (e) => {
  Ue(new URL(e.url).host) && e.headers.set(Nt, "true");
}, Ht = "X-Fondof-Is-Canary", Jt = (e) => {
  Be() && e.headers.set(Ht, "true");
}, Ut = "X-Fondof-Internal", Bt = (e) => {
  Le() && e.headers.set(Ut, "true");
}, Lt = "Accept-Language", Ft = {
  de: "de_DE,de;q=0.8",
  en: "en_US,en;q=0.8",
  fr: "fr_FR,fr;q=0.8",
  es: "es_ES,es;q=0.8",
  da: "da_DK,dk;q=0.8",
  it: "it_IT,it;q=0.8"
}, $t = () => Ft[$e()], Kt = (e) => e.headers.set(Lt, $t());
let E;
const Gt = new Uint8Array(16);
function Vt() {
  if (!E && (E = typeof crypto < "u" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto), !E))
    throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
  return E(Gt);
}
const b = [];
for (let e = 0; e < 256; ++e)
  b.push((e + 256).toString(16).slice(1));
function Xt(e, t = 0) {
  return b[e[t + 0]] + b[e[t + 1]] + b[e[t + 2]] + b[e[t + 3]] + "-" + b[e[t + 4]] + b[e[t + 5]] + "-" + b[e[t + 6]] + b[e[t + 7]] + "-" + b[e[t + 8]] + b[e[t + 9]] + "-" + b[e[t + 10]] + b[e[t + 11]] + b[e[t + 12]] + b[e[t + 13]] + b[e[t + 14]] + b[e[t + 15]];
}
const Yt = typeof crypto < "u" && crypto.randomUUID && crypto.randomUUID.bind(crypto), ie = {
  randomUUID: Yt
};
function Wt(e, t, n) {
  if (ie.randomUUID && !e)
    return ie.randomUUID();
  e = e || {};
  const r = e.random || (e.rng || Vt)();
  return r[6] = r[6] & 15 | 64, r[8] = r[8] & 63 | 128, Xt(r);
}
const oe = "X-Anonymous-Customer-Unique-Id", se = "uuid", ae = Xe.create("localStorage"), Qt = (e) => {
  let t = e.headers.get(oe) || ae.get(se);
  t || (t = Wt(), ae.set(se, t)), e.headers.set(oe, t);
}, F = (e, t) => {
  const n = [];
  for (const [r, o] of Object.entries(e))
    t[r] && n.push(o);
  return n;
}, Zt = (e) => (t, n) => {
  const r = F(e, n);
  for (const o of r) {
    const i = o(t, n);
    if (i instanceof Response)
      return i;
  }
}, er = (e) => async (t, n, r) => {
  const o = F(e, n);
  for (const i of o) {
    const s = await i(t, n, r);
    s instanceof Response && (r = s);
  }
  return r;
}, tr = (e, t) => {
  const n = F(e, t);
  for (const r of n)
    t = r(t);
  return t;
}, rr = lt.extend({
  timeout: !1,
  retry: 0,
  headers: {
    Accept: "application/vnd.api+json",
    "Content-Type": "application/vnd.api+json;version=1.1"
  },
  fondOfInternal: !0,
  auth: !0,
  language: !0,
  uuid: !1,
  deserialize: !1,
  beta: !0,
  canary: !0
}), ur = {
  new: (e = {}) => {
    var t, n, r;
    return e.hooks = {
      ...e.hooks || {},
      beforeRequest: [
        Zt({
          fondOfInternal: Bt,
          auth: kt,
          language: Kt,
          uuid: Qt,
          beta: xt,
          canary: Jt
        }),
        ...((t = e.hooks) == null ? void 0 : t.beforeRequest) || []
      ],
      afterResponse: [
        er({
          deserialize: jt
        }),
        ...((n = e.hooks) == null ? void 0 : n.afterResponse) || []
      ],
      beforeError: [...((r = e.hooks) == null ? void 0 : r.beforeError) || [], Ct]
    }, tr(
      {
        shopPrefixUrl: Dt
      },
      e
    ), rr.extend(e);
  }
}, nr = (e) => (e == null ? void 0 : e.name) === "HTTPError", cr = (e) => nr(e) && e.response.status === 404;
export {
  ur as default,
  St as deserialize,
  nr as isHttpError,
  cr as isHttpNotFoundError
};
//# sourceMappingURL=api-client.js.map
